import React, { createContext, useReducer, useContext } from 'react';


const selectedProfile = JSON.parse(sessionStorage.getItem('zeptoProfile'))

// Initial state for the context
const initialState = {
  selectedZeptoProfile: {
    ...( selectedProfile ? { ...selectedProfile } : {} )
  },
  zeptoProfiles: [],
};

// Define the reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_SELECTED_ZEPTO_PROFILE':
      return { ...state, selectedZeptoProfile: action.payload };
    case 'UPDATE_ZEPTO_PROFILES':
        return { ...state, zeptoProfiles: action.payload };
        default:
      return state;
  }
};

// Create the context
const ZeptoContext = createContext();

// Create a custom hook to use the context
const useZeptoContext = () => {
  const context = useContext(ZeptoContext);
  if (!context) {
    throw new Error('useZeptoContext must be used within a ZeptoProvider');
  }
  return context;
};

// Create the provider component
const ZeptoProvider = ({ children }) => {
  const [zeptoState, zeptoDispatch] = useReducer(reducer, initialState);

  return (
    <ZeptoContext.Provider value={{ zeptoState, zeptoDispatch }}>
      {children}
    </ZeptoContext.Provider>
  );
};

export { ZeptoProvider, useZeptoContext };